/* Add accessible names to app-owned controls that arrive after Liquid has
   rendered. The observer is intentionally short-lived to avoid permanent
   mutation overhead after review widgets and preview controls have loaded. */
(function () {
  let queued = false;

  function labelInjectedMarkup() {
    queued = false;

    document.querySelectorAll('iframe#PBarNextFrame:not([title])').forEach(function (frame) {
      frame.title = 'Shopify theme preview controls';
    });

    document.querySelectorAll('.jdgm-ugc-media img:not([alt]), .jdgm-cards-carousel img:not([alt])').forEach(function (image) {
      image.alt = '';
    });

    document.querySelectorAll('.jdgm-ugc-media a:not([aria-label])').forEach(function (link) {
      if (!link.textContent.trim()) link.setAttribute('aria-label', 'View customer review media');
    });

    document.querySelectorAll('.jdgm-cards-carousel .jdgm-arrow:not([aria-label])').forEach(function (button, index) {
      button.setAttribute('aria-label', index % 2 === 0 ? 'Previous reviews' : 'Next reviews');
    });

    document.querySelectorAll('.jdgm-cards-carousel a[href*="/products/"]:not([aria-label])').forEach(function (link) {
      if (link.textContent.trim()) return;
      const card = link.closest('.jdgm-card');
      const productName = card ? card.querySelector('.jdgm-product-name') : null;
      link.setAttribute('aria-label', productName ? `View ${productName.textContent.trim()}` : 'View Circ Bites product');
    });
  }

  function queueLabels() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(labelInjectedMarkup);
  }

  queueLabels();
  const observer = new MutationObserver(queueLabels);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(function () {
    observer.disconnect();
    labelInjectedMarkup();
  }, 10000);
})();
